// src/feedback/feedbackLauncher.ts — Floating Victorian Brass Compass Launcher

import { tokens } from '../ui/designTokens';
import { soundEngine } from '../audio/soundEngine';
import { FeedbackDrawer } from './feedbackDrawer';

export class FeedbackLauncher {
  private container: HTMLElement;
  private drawer: FeedbackDrawer;

  constructor(drawer: FeedbackDrawer) {
    this.drawer = drawer;
    this.container = document.createElement('div');
    this.container.id = 'feedback-launcher-root';
    this.render();
    this.attachGlobalShortcut();
  }

  getElement(): HTMLElement {
    return this.container;
  }

  getDrawer(): FeedbackDrawer {
    return this.drawer;
  }

  private render(): void {
    this.container.innerHTML = `
      <button
        id="feedback-floating-btn"
        class="touch-target"
        style="
          position: fixed;
          bottom: 24px;
          right: 24px;
          width: 54px;
          height: 54px;
          border-radius: 50%;
          background: radial-gradient(circle, #1A365D 0%, #0A192F 100%);
          border: 2px solid ${tokens.color.gildedBrass};
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.45), 0 0 12px rgba(197, 160, 89, 0.4);
          color: #FFFDF9;
          font-size: 1.4rem;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 990;
          transition: transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.2s ease;
          outline: none;
        "
        aria-label="Open Atelier Feedback Inspector"
        title="Open Inspector Clawey Feedback (Shift + F)"
      >
        <span style="display: flex; align-items: center; justify-content: center;">
          🦞
        </span>
        <span style="
          position: absolute;
          top: -2px;
          right: -2px;
          width: 14px;
          height: 14px;
          border-radius: 50%;
          background: #0284C7;
          border: 1.5px solid #0A192F;
          box-shadow: 0 0 6px #0284C7;
        "></span>
      </button>
    `;

    const btn = this.container.querySelector<HTMLButtonElement>('#feedback-floating-btn');
    if (btn) {
      btn.addEventListener('mouseenter', () => {
        btn.style.transform = 'scale(1.1) translateY(-2px)';
        btn.style.boxShadow = '0 6px 24px rgba(0, 0, 0, 0.5), 0 0 16px rgba(197, 160, 89, 0.6)';
      });
      btn.addEventListener('mouseleave', () => {
        btn.style.transform = 'scale(1) translateY(0)';
        btn.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.45), 0 0 12px rgba(197, 160, 89, 0.4)';
      });
      btn.addEventListener('click', () => {
        soundEngine.playTap();
        this.drawer.open();
      });
    }
  }

  private attachGlobalShortcut(): void {
    if (typeof window === 'undefined') return;
    window.addEventListener('keydown', (e) => {
      // Shift + F opens feedback drawer if not typing in input
      if (e.shiftKey && (e.key === 'F' || e.key === 'f')) {
        const activeTag = document.activeElement?.tagName.toLowerCase();
        if (activeTag !== 'input' && activeTag !== 'textarea') {
          e.preventDefault();
          this.drawer.open();
        }
      }
    });
  }
}
